import React from 'react';

import AiChatDrawer from './AiChatDrawer';
import AiOpsChatIframeDrawer from './AiOpsChatIframeDrawer';

export function isAiChatDisabled(): boolean {
  return window.configs?.AI_CHAT_DISABLED === 'true';
}

function hasAiOpsChatOrigin(): boolean {
  return Boolean(window.configs?.AI_OPS_CHAT_ORIGIN?.trim());
}

export default function AiChatEntry() {
  if (isAiChatDisabled()) {
    return null;
  }

  if (hasAiOpsChatOrigin()) {
    return <AiOpsChatIframeDrawer />;
  }

  return <AiChatDrawer />;
}
